import { FunctionComponent } from 'react';
import { useMediaGalleryCarousel } from '../../../../contexts/MediaGalleryCarouselContext/MediaGalleryCarouselContext';
import { MediaItemV2 } from '../../../../../app-kit/components/Image/types';
import {
  SearchByImageFeatureButton,
  SearchByImageFeatureButtonWrapper,
} from '../../../../../components/SearchByImageButton/SearchByImageButton';
import { mediaHelper, spacingHelper } from '@property.com.au/ui-kit';
import { styled } from 'styled-components';

const CLOSE_BUTTON_SIZE_PLUS_MARGIN_RIGHT_PX = 44;

const SearchByImageWrapper = styled(SearchByImageFeatureButtonWrapper)`
  position: absolute;
  top: ${spacingHelper('small')};
  right: calc(${CLOSE_BUTTON_SIZE_PLUS_MARGIN_RIGHT_PX}px + ${spacingHelper('medium')});
  z-index: 1;
  pointer-events: auto;

  ${mediaHelper('tabletMax')} {
    right: calc(${CLOSE_BUTTON_SIZE_PLUS_MARGIN_RIGHT_PX}px + ${spacingHelper('extraSmall')});
  }
`;

export const MediaGalleryImageSearchButton: FunctionComponent<{
  galleryItems: Array<MediaItemV2>;
}> = ({ galleryItems }) => {
  const { currentSlide } = useMediaGalleryCarousel();

  const currentSearchByImageButton = galleryItems[currentSlide].searchByImageButton;

  if (!currentSearchByImageButton) return null;

  return (
    <SearchByImageWrapper>
      <SearchByImageFeatureButton searchByImageButton={currentSearchByImageButton} />
    </SearchByImageWrapper>
  );
};
